/**
 * SmartQueueFilterChips — Section-3 filter chips (iter114s.75).
 *
 * Clicking a chip swaps the queue keyword and triggers a re-fetch of
 * the cockpit data. No page reload. The chip list mirrors the
 * priority buckets above + a few view-mode chips (rush / reseller /
 * today / stuck) the operator brief called out.
 */
import React from 'react';

const CHIPS = [
  { id: 'new',                label: 'New Orders' },
  { id: 'proof_revisions',    label: 'Proof Revisions' },
  { id: 'rush',               label: 'Rush' },
  { id: 'awaiting_supplier',  label: 'Awaiting Supplier' },
  { id: 'stuck',              label: 'Stuck' },
  { id: 'reseller',           label: 'Reseller' },
  { id: 'today',              label: 'Today' },
  { id: 'tracking_missing',   label: 'Tracking Missing' },
  { id: 'files_failed',       label: 'Files Failed' },
  { id: 'all',                label: 'All Active' },
];

export const SmartQueueFilterChips = ({ current, onChange }) => (
  <div
    className="flex flex-wrap items-center gap-2 mb-4"
    data-testid="smart-queue-filter-chips"
  >
    {CHIPS.map((chip) => {
      const active = current === chip.id;
      return (
        <button
          key={chip.id}
          type="button"
          onClick={() => onChange(chip.id)}
          data-testid={`chip-${chip.id}`}
          aria-pressed={active}
          className={`text-xs font-semibold rounded-full px-3 py-1.5 transition-colors border ${
            active
              ? 'bg-[#2F5D3A] text-white border-[#2F5D3A] shadow'
              : 'bg-white text-[#14281D] border-[#E5E7EB] hover:border-[#6FBF73] hover:bg-[#F4FBF6]'
          }`}
        >
          {chip.label}
        </button>
      );
    })}
  </div>
);

export default SmartQueueFilterChips;
